import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

const SaveButton = ({id, color, label, onClick, 
    iconClassName, loadingIconClassName, errorIconClassName,
    startLoadingCriteria, endLoadingCriteria, errorLoadingCriteria, 
    confirmMessage}) => {

    const [icon, setIcon] = useState(iconClassName);

    useEffect(() => {
        if(startLoadingCriteria) setIcon(loadingIconClassName)
        if(errorLoadingCriteria) setIcon(errorIconClassName)
        if(endLoadingCriteria) {
            setIcon(iconClassName)
            if(confirmMessage) showConfirm(confirmMessage)
        }

    }, [startLoadingCriteria, loadingIconClassName, 
        endLoadingCriteria, iconClassName, confirmMessage, 
        errorLoadingCriteria, errorIconClassName])

    const showConfirm = (message) => {
        confirmAlert({
          message: message,
          buttons: [
            {
                label: 'OK',
                onClick: () => {}
            }
          ]
        });
    };

    return (
        <Button id={id} color={color} style={{whiteSpace: "nowrap"}} onClick={ onClick } >
            <span className={icon}></span> {label}
        </Button>
    );
};

export default SaveButton;